<template>
  <!-- Needs Confirmation -->
  <v-content class="candidate email-confirmation banner" v-if="needConfirmation" style="max-height: 76px;">
    <v-alert class="my-0" :color="themes.candidate.light.error" :value="needConfirmation">
      <v-container class="pa-0">
        <v-layout>
          <v-icon dark left>mdi-alert-circle</v-icon>
          <div class="py-2 subheading" v-if="confirmationExpiry > new Date()">
            Please verify your email address
            <strong>{{ user.unconfirmedEmail ? user.unconfirmedEmail : user.email }}</strong> within
            {{ timeToExpiry }}
          </div>
          <div class="py-2 subheading" v-else>
            <strong>{{ user.unconfirmedEmail ? user.unconfirmedEmail : user.email }}</strong> email
            verification expired, please click resend verification
          </div>
          <v-spacer />
          <v-btn dark outline small @click="sendEmailConfirmation" :loading="sending">
            <v-icon left>mdi-email</v-icon> Resend Verification
          </v-btn>
        </v-layout>
      </v-container>
    </v-alert>
  </v-content>
</template>

<script>
export default {
  data() {
    return {
      sending: false,
    }
  },
  computed: {
    confirmationExpiry() {
      if (!this.user || this.role !== 'candidate') return

      let sentAt = new Date(this.user.confirmationSentAt)
      return new Date(sentAt.setDate(sentAt.getDate() + 1))
    },
    needConfirmation() {
      return this.user && this.user.id && this.user.confirmationSentAt && !this.user.confirmedAt
    },
    role() {
      return this.$store.getters['auth/role']
    },
    timeToExpiry() {
      if (!this.confirmationExpiry) return

      return this.$inWords(this.confirmationExpiry).replace('about ', '')
    },
    user() {
      return this.$store.getters['auth/user']
    },
  },
  methods: {
    delay: t => new Promise(resolve => setTimeout(resolve, t)),
    sendEmailConfirmation() {
      if (this.role === 'candidate') {
        this.sending = true
        this.$http
          .get('candidate/candidate/send_email_confirmation')
          .then(() => this.delay(7000))
          .then(() => this.$store.dispatch('auth/refresh'))
          .then(() => (this.sending = false))
      }
    },
  },
}
</script>
